import { BetButtons } from "./BetButtons";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../managers/AudioManager";
import { RoomManager } from "../../../managers/RoomManager";
import { Button } from "../../../utils/Button";
import { CardsButtons } from "./CardsButtons";
import { RoomScene } from "../RoomScene";
import { Translation } from "../../../Translation";

export class GUI extends Phaser.GameObjects.Container {

    private betButtons: BetButtons;
    private cardsButtons: CardsButtons;
    private skipButton: Phaser.GameObjects.Container;
    private leaveButton: Phaser.GameObjects.Container;
    private rejoinButton: Phaser.GameObjects.Container;
    private waitingText: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const topBackground = new Phaser.GameObjects.Graphics(this.scene);
        topBackground.fillStyle(0x000000, .75);
        topBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, 70);
        this.add(topBackground);

        const backButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_menu.png", "btn_menu.png", true, true);
        backButton.scaleX = GameVars.scaleX;
        backButton.onUp(this.onClickBack, this);
        this.add(backButton);


        if (GameConstants.ANIMATION_SCENES) {
            const playersButton = new Button(this.scene, 35 * GameVars.scaleX, 105, "texture_atlas_1", "btn_players.png", "btn_players.png", true, true);
            playersButton.scaleX = GameVars.scaleX;
            playersButton.alpha = .75;
            playersButton.onUp(this.onClickPlayers, this);
            this.add(playersButton);

            const bananaButton = new Button(this.scene, 100 * GameVars.scaleX, 105, "texture_atlas_1", "btn_banana.png", "btn_banana.png", true, true);
            bananaButton.scaleX = GameVars.scaleX;
            bananaButton.alpha = .75;
            bananaButton.onUp(this.onClickBanana, this);
            this.add(bananaButton);
        }

        const winningHandsButton = new Button(this.scene, GameConstants.GAME_WIDTH - 100 * GameVars.scaleX, 35, "texture_atlas_1", "btn_winning_hands.png", "btn_winning_hands.png", true, true);
        winningHandsButton.scaleX = GameVars.scaleX;

        if (this.scene.sys.game.device.os.desktop) {
            winningHandsButton.onOver(this.onClickWinningHands, this);
            winningHandsButton.onOut(this.onOutWinningHands, this);
        } else {
            winningHandsButton.onUp(this.onClickWinningHands, this);
        }

        this.add(winningHandsButton);

        const audioButton: Phaser.GameObjects.Image = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH - 35 * GameVars.scaleX, 35, "texture_atlas_1");

        if (GameVars.gameData.muted) {
            audioButton.setFrame("btn_sound_off.png");
        } else {
            audioButton.setFrame("btn_sound_on.png");
        }

        audioButton.setInteractive();

        audioButton.on("pointerdown", () => {
            audioButton.setScale(GameVars.scaleX, 1);
        }, this);

        audioButton.on("pointerup", () => {
            this.onDownAudioButton(audioButton);
        }, this);

        audioButton.on("pointerover", () => {
            audioButton.setScale(GameVars.scaleX * 1.05, 1.05);
        }, this);

        audioButton.on("pointerout", () => {
            audioButton.setScale(GameVars.scaleX, 1);
        }, this);

        audioButton.scaleX = GameVars.scaleX;
        this.add(audioButton);

        let bck = this.scene.add.image(0, GameConstants.GAME_HEIGHT, "texture_atlas_1", "shade_bottom.png");
        bck.setOrigin(0, 1);
        bck.scaleX = GameConstants.GAME_WIDTH / bck.width;
        this.add(bck);

        this.betButtons = new BetButtons(this.scene, this);
        this.add(this.betButtons);

        this.cardsButtons = new CardsButtons(this.scene, this);
        this.add(this.cardsButtons);

        // FOLD AND SKIP

        this.skipButton = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 50);
        this.skipButton.scaleX = GameVars.scaleX;
        this.skipButton.visible = false;
        this.add(this.skipButton);

        let skipButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_blue.png", "btn_blue.png", true);
        skipButton.onUp(this.onClickSkip, this);

        this.skipButton.add(skipButton);

        let skipText = new Phaser.GameObjects.Text(this.scene, 0, 0, Translation.getText("SKIP"), { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#064150", align: "center" });
        skipText.setOrigin(.5);
        this.skipButton.add(skipText);

        this.leaveButton = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2 + 100, GameConstants.GAME_HEIGHT - 50);
        this.leaveButton.scaleX = GameVars.scaleX;
        this.leaveButton.visible = false;
        this.add(this.leaveButton);

        let leaveButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_red.png", "btn_red.png", true);
        leaveButton.onUp(this.onClickLeave, this);

        this.leaveButton.add(leaveButton);

        let leaveText = new Phaser.GameObjects.Text(this.scene, 0, 0, Translation.getText("LEAVE_TABLE"), { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#871947", align: "center" });
        leaveText.setOrigin(.5);
        this.leaveButton.add(leaveText);

        this.rejoinButton = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2 - 100, GameConstants.GAME_HEIGHT - 50);
        this.rejoinButton.scaleX = GameVars.scaleX;
        this.rejoinButton.visible = false;
        this.add(this.rejoinButton);

        let rejoinButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        rejoinButton.onUp(this.onClickRejoin, this);

        this.rejoinButton.add(rejoinButton);

        let rejoinText = new Phaser.GameObjects.Text(this.scene, 0, -12, Translation.getText("REJOIN_GAME"), { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#871947", align: "center" });
        rejoinText.setOrigin(.5);
        this.rejoinButton.add(rejoinText);

        let rejoinAmountText = new Phaser.GameObjects.Text(this.scene, -30, 12, "+500", { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#871947", align: "center" });
        rejoinAmountText.setOrigin(.5);
        this.rejoinButton.add(rejoinAmountText);

        const chipIcon = new Phaser.GameObjects.Image(this.scene, rejoinAmountText.x + rejoinAmountText.displayWidth / 2 + 15, 12, "texture_atlas_1", "chip_pot_icon.png");
        chipIcon.setScale(.7);
        this.rejoinButton.add(chipIcon);

        const videoIcon = new Phaser.GameObjects.Image(this.scene, chipIcon.x + chipIcon.displayWidth / 2 + 18, 12, "texture_atlas_0", "adbutton_icon.png");
        videoIcon.setScale(.9);
        this.rejoinButton.add(videoIcon);

        this.deactivate();
    }

    public setValues(): void {

        this.betButtons.setValues();
    }

    public activate(): void {

        this.betButtons.acivate();
    }

    public deactivate(): void {

        this.betButtons.deactivate();
    }

    public showSkip(): void {

        this.skipButton.visible = true;
    }

    public hideSkip(): void {

        this.skipButton.visible = false;
    }

    public showLeave(): void {

        if (GameConstants.AI_MODE) {
            return;
        }

        this.leaveButton.visible = true;

        if (GameConstants.REWARDED_ADS && window.advertisement.isRewardedAdReady()) {
            this.rejoinButton.visible = true;
        }
    }

    public hideLeave(): void {

        this.leaveButton.visible = false;
    }

    public showCardsButtons(): void {

        this.cardsButtons.visible = true;
    }

    public removeWaitingText(): void {

        if (this.waitingText) {
            this.scene.tweens.killTweensOf(this.waitingText);
            this.waitingText.destroy();
            this.waitingText = null;
        }
    }

    private onClickSkip(): void {

        AudioManager.playSound("btn_click");

        RoomManager.changeSpeed(10);
        RoomManager.hideBananaPopcorns();
        this.hideSkip();
    }

    private onClickRejoin() {

        this.rejoinButton.setVisible(false);
        this.leaveButton.setVisible(false);
        window.advertisement.showRewardedAd(success => {
            if (success) {
                RoomManager.queueRejoinPlayer(500);
                GameVars.gameData.chips -= 500;
                if (GameVars.gameData.chips < 0) {
                    GameVars.gameData.chips = 0;
                }
                GameVars.gameOver = false;
                this.waitingText = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 50, Translation.getText("WAITING") + "...", { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#FFFFFF", align: "center" });
                this.waitingText.setOrigin(0.5);
                this.scene.add.tween({
                    targets: this.waitingText,
                    alpha: 0,
                    repeat: -1,
                    yoyo: true,
                })
                this.add(this.waitingText);
            } else {
                GameVars.gameOver = true;
                this.leaveButton.setVisible(true);
            }
        }, this);
    }

    private onClickLeave(): void {

        AudioManager.playSound("btn_click");

        RoomManager.onBackButtonPressed();
    }

    private onClickPlayers(): void {

        AudioManager.playSound("btn_click");

        GameVars.currentScene.scene.start("AnimationScene");
    }

    private onClickBanana(): void {

        AudioManager.playSound("btn_click");

        GameVars.currentScene.scene.start("BananaScene");
    }

    private onDownAudioButton(b: Phaser.GameObjects.Image): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            b.setFrame("btn_sound_off.png");
        } else {
            b.setFrame("btn_sound_on.png");
        }

        AudioManager.playSound("btn_click");
    }

    private onClickBack(): void {

        AudioManager.playSound("btn_click");

        RoomManager.onBackButtonPressed();
    }

    private onClickWinningHands(): void {

        AudioManager.playSound("btn_click");

        RoomManager.onWinningHandsPressed();
    }

    private onOutWinningHands(): void {

        AudioManager.playSound("btn_click");

        RoomScene.currentInstance.removeWinningHandsLayer();
    }
}
